import { useProNavigate } from '@mp/contexts';
import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useApplicationMutations = () => {
  const { axios } = useNetworkRequest();
  const queryClient = useQueryClient();
  const { navigate } = useProNavigate();

  const { mutate: nextStep, isLoading: nextLoading } = useMutation(() =>
    axios.patch(`/v3/professional/application_wizard/next`),
  );

  const { mutate: nextStepWithValues, isLoading: nextWithValuesLoading } = useMutation(
    (values: unknown) => axios.patch(`/v3/professional/application_wizard/next`, values),
  );

  const { mutate: prevStep, isLoading: prevLoading } = useMutation(() => {
    return axios.patch(`/v3/professional/application_wizard/back`);
  });

  const { mutate: prevStepWithInvalidate, isLoading: isPrevWithInvalidateLoading } = useMutation(
    () => {
      return axios.patch(`/v3/professional/application_wizard/back`);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['currentUser']);
        navigate('Application');
      },
    },
  );

  return {
    nextStep,
    nextStepWithValues,
    prevStep,
    prevStepWithInvalidate,
    isLoading: nextLoading || prevLoading || nextWithValuesLoading || isPrevWithInvalidateLoading,
  };
};
